import React from "react";
import PropTypes from "prop-types";
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import ReactionButtons from './ReactionButtons';


class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answer: '',
      score: null,
      reaction: null,
      comment: '',
      containerClass: '',
    };
    this.wrapperRef = React.createRef();
    this.loadingRef = React.createRef();
    this.commentRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.submitQuestion = this.submitQuestion.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.toggleQuestionAnswer = this.toggleQuestionAnswer.bind(this);
    this.resetScreen = this.resetScreen.bind(this);
    this.fade = this.fade.bind(this);
    this.handleReact = this.handleReact.bind(this);
    this.handleNumberInputChange = this.handleNumberInputChange.bind(this);
  }


  componentDidMount() {
    setTimeout(
      () => {
        this.wrapperRef.current.classList.remove('transparent');
      },
      200
    )
  }


  handleChange(e, field='answer'){
    let value = e;
    if(typeof e !== 'number') value = e.target.value;
    const newState = this.state;
    newState[field] = value;
    this.setState(newState);
  }


  // Maximum number for 50% ownership question is 5,438,100
  // Min / Max attrs on <input> only works when using buttons.
  // This method prevents manual input over limit.
  // If over limit, show Alert popup and don't update state.
  handleNumberInputChange(e){
    let value = e.target.value;
    if(value > 5438100) {
      alert('5,438,100 is the maximum number allowed')
    } else {
      const newState = this.state;
      newState['answer'] = value;
      this.setState(newState);
    }
  }


  // Get Score, then reveal Answer
  submitQuestion(){
    this.setState({ score: this.calculateScore()}, this.toggleQuestionAnswer);
  }


  calculateScore(){
    let ans = this.state.answer;
    if(ans === '') ans = 0; // Catch empty Answers and convert to 0
    if(typeof ans === 'string') ans = Number(ans); // Ensure answer is a number
    return this.minMax() ? this.calculatePercent(ans) : this.calculateCorrect(ans);
  }


  minMax(){
    const hasMin = Object.keys(this.props.question).includes('min');
    const hasMax = Object.keys(this.props.question).includes('max');
    return hasMin && hasMax;
  }


  // Calculate score as % of correctness
  calculatePercent(answer){
    // 1, work out difference between correct and given answer
    // 2. Use Square and Square root to convert any negatives to positive
    // 3. Establish percentage difference based on max range of question.
    // Example where MAX = 10, CORRECT = 50, GIVEN = 40
    //    50 - 60 = -10
    //    -10 * -10 = 100
    //    Square root of 100 = 10
    //    ( 1 - ( 10 / 100 ) ) * 100  = 90
    //     Score is 90% correct
    const diff = this.props.question.correct - answer;
    const sq = Math.pow(diff, 2);
    const pos = Math.sqrt(sq);
    return ( 1 - ( pos / this.props.question.max ) ) * 100;
  }


  calculateCorrect(answer){
    return answer === this.props.question.correct ? 100 : 0;
  }


  resetScreen(response){
    this.fade();
    setTimeout(
      () => {
        this.props.nextQuestion(response);
        this.toggleQuestionAnswer();
        this.commentRef.current.classList.add('transparent');
      },
      500
    );
    setTimeout(this.fade, 1300)
  }


  fade(){
    this.wrapperRef.current.classList.toggle('transparent');
    this.loadingRef.current.classList.toggle('transparent');
  }


  // Move Question away to reveal Answer
  toggleQuestionAnswer(){
    this.wrapperRef.current.classList.toggle('shift-left');
  }


  handleNext(){
    // Collate data for Survey record
    const response = {
      number: this.props.question.number,
      answer: this.state.answer,
      reaction: this.state.reaction,
      comment: this.state.comment,
      score: this.state.score
    }

    this.props.saveResponse(response); // Save Record in Parent (Quiz) state

    // Submit Survey, navigating to the Aspirations page if finished
    if(this.props.isLast) this.props.finishQuiz();
    // if not finished, reset the UI and load next question
    else this.resetState(() => this.resetScreen(response));
  }


  resetState(callback = undefined){
    this.setState({
      answer: '',
      // score: null,
      reaction: null,
      comment: '',
    }, () => { if(callback) callback() })
  }


  // can i swap this for a handleChange
  handleReact(reaction){
    this.setState(
      { reaction: reaction },
      () => {
        this.commentRef.current.classList.remove('transparent');
        // this.commentRef.current.focus();
      }
    );
  }


  setResultMessage(){
    if(this.state.score === 100) return 'Exactly Right!';
    else if(this.state.score >= 90) return 'Almost!';
    else if(this.state.score >= 85) return 'You were close!';
    else if(this.state.score >= 75) return 'Good Effort!';
    else if(this.state.score < 75 && this.state.score > 0) return 'Sorry!';
  }


  render () {

    const {
      number,
      question,
      fact,
      source,
      min,
      max,
      correct
    } = this.props.question;

    return (

      <React.Fragment>

        {/*  LOADING DIALOG  */}
        <div
          ref={this.loadingRef}
          className='fixed full-height full-width top left flex-container align-center-middle transparent'
          id='loading-dialog'
        >
          <p className='italic bold lead'>Loading next question...</p>
        </div>


        {/*  Q&A WRAPPER  */}
        <div className={`wrapper overflow-hidden transparent`} ref={this.wrapperRef}>
          <div className='question-and-answer'>
            <div
              id='question'
              className='mpl mpr flex-container align-center grid-x'
            >
              <article className='cell medium-8'>
                <h1 className='text-center'>
                  {question}
                </h1>

                {/* SLIDER for all Questions except 6  */}
                {number !== 6 &&
                  <React.Fragment>

                    <p className='text-center italic'>
                      Use the slider to set your answer. If you don't know, take a guess.
                    </p>

                    <h2
                      className='text-center slider-answer'>{this.state.answer}%</h2>

                    <div
                      className='slider-container mpt lpb flex-container align-middle'
                    >
                      <span
                        style={{paddingRight:10}}
                      >
                        {min}%
                      </span>

                      <Slider
                        style={{
                          padding:0,
                          marginRight:'0.7rem',
                          marginLeft:'0.7rem'
                        }}
                        min={min}
                        max={max}
                        defaultValue={0}
                        value={this.state.answer}
                        // handle={handle}
                        onChange={this.handleChange}
                        handleStyle={[{ height: '2rem', width: '2rem'}]}
                        trackStyle={[{ height: '1rem' }]}
                        railStyle={{ height: '1rem' }}
                      />

                      <span
                        style={{paddingLeft:10}}
                      >
                        {max}%
                      </span>

                    </div>

                  </React.Fragment>
                }

                {/*  Text Input for Q6  */}
                {number === 6 &&
                  <input
                    className='mmt mmb'
                    min={'0'}
                    max={'5438100'}
                    type="number"
                    value={this.state.answer}
                    onChange={this.handleNumberInputChange}
                    placeholder={'Please type your answer...'}
                  />
                }

                <button
                  className='button expanded'
                  onClick={this.submitQuestion}
                  disabled={this.state.answer === ''}
                >
                  <h4>
                    Submit
                  </h4>
                </button>

              </article>

            </div> {/*  END OF QUESTION  */}


            <div
              id='answer'
              className='mpl mpr flex-container align-center grid-x'
            >

              <article className='cell medium-8'>

                <h1 className='text-center'>
                  {this.setResultMessage()}
                </h1>

                <h3 className='light text-center nmb smb-minus'>
                  The answer is:
                </h3>

                <h1 className='text-center answer-text'>
                  {correct + (number !== 6 ? '%' : '')}
                </h1>

                <p
                  className='text-center lmb lead lighter-gray-trans-bg border-radius sp'
                >
                  {fact + '  '}

                  <br/>

                  <span className='italic h7 mmt-minus'>
                    {'Source: ' + source}
                  </span>
                </p>

                <h4
                  className='text-center smb'
                >
                  How does this make you feel?
                </h4>

                <ReactionButtons
                  reaction={this.state.reaction}
                  react={this.handleReact}
                />

                <textarea
                  ref={this.commentRef}
                  className='question-comment transparent'
                  name={`${number}`}
                  id={`question-${number}-comment`}
                  value={this.state.comment}
                  onChange={(e)=>this.handleChange(e, 'comment')}
                  placeholder='Tell us why...'
                  cols="30" rows="2"
                />

                {/* Reacting enables button */}
                <button
                  disabled={!this.state.reaction}
                  className='button expanded nmb'
                  onClick={this.handleNext}
                >
                  Next
                </button>


              </article>

            </div> {/*  END OF ANSWER  */}
          </div> {/*  END OF QUESTION AND ANSWER */}
        </div> {/*  END OF Q&A WRAPPER  */}

      </React.Fragment>
    );
  }
}

export default Question
